import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import type { TableRowRange } from 'components/Table/model/TableModel';

interface HandleRequestTableRowRangeCommand {
  rowRange: TableRowRange;
}

export const handleRequestTableRowRange: ApiTableCommandFactory<
  HandleRequestTableRowRangeCommand
> = (cmdContext) => (command) => {
  cmdContext
    .getLazyLoadRows()
    .handleRequestRowRange(
      command.rowRange.startIndex,
      command.rowRange.endIndex,
    );
};
